import {styled} from "styled-components";
import {Card} from "antd";

export const StyledCard = styled(Card)`
    box-shadow: -9px 5px 22px -19px rgba(0, 0, 0, 0.75);
    margin-bottom: 15px;
    .ant-flex{
        margin-bottom: 0!important;
    }
    .ant-form-item{
        margin-bottom: 0;
    }
    .ant-card-body{
        padding: 10px 10px;
    }
`;